<div class="user-area-wrapper">
  <ng-container *ngIf="emptyFavorites$ | async">
    <opac-no-results [label]="'lists.noFavorites' | translate"> </opac-no-results>
  </ng-container>

  <ng-container *ngIf="paginatedFavorites$ | async as paginatedFavorites">
    <div class="view-more__header">
      <div class="view-more__header__title">
        <h2>{{'user.favorites.title' | translate}}</h2>
        <span class="subheader">{{ paginatedFavorites.itemsTotal }} {{'general.items' | translate}}</span>
      </div>
      <div class="view-more__header__actions">
        <opac-button *ngIf="paginatedFavorites.items.length" type="tertiary" (click)="deleteAll()">
          {{ "general.removeAll" | translate }}
        </opac-button>
      </div>
    </div>

    <h1 class="user-area-title">{{'user.favorites.title' | translate}}</h1>

    <div *ngIf="paginatedFavorites.items.length" class="record-card-grid">
      <app-user-favorite-item *ngFor="let favorite of paginatedFavorites.items.slice(0, favoritesLimit)" [favorite]="favorite"></app-user-favorite-item>
    </div>

    <opac-infinite-scroll
      [disabled]="(isLoading$ | async) || paginatedFavorites.page === paginatedFavorites.numPages -1"
      [threshold]="100"
      (load)="loadMore()"></opac-infinite-scroll>
  </ng-container>
</div>
